import { render, staticRenderFns } from "./lapCustom_v2.vue?vue&type=template&id=66910934&"
import script from "./lapCustom_v2.vue?vue&type=script&lang=js&"
export * from "./lapCustom_v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QSeparator,QSelect,QItem,QItemSection,QIcon,QPopupProxy,QDate,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QInput,QBtn,QSeparator,QSelect,QItem,QItemSection,QIcon,QPopupProxy,QDate,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
